<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="questions"
          sort-by="calories"
          class="elevation-1"
        >
          <template #top>
            <v-toolbar flat>
              <v-toolbar-title>Fragen</v-toolbar-title>
              <v-divider class="mx-4" inset vertical />
              <v-spacer />
              <v-dialog v-model="dialog" max-width="800px">
                <template #activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    New Item
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container fluid>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            v-model="itemForm.title"
                            :error-messages="itemForm.errors.title"
                            label="Title"
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="itemForm.form_component"
                            :error-messages="itemForm.errors.form_component"
                            label="Form Component"
                          />
                        </v-col>
                        <v-col cols="12">
                          <v-autocomplete
                            v-model="itemForm.questionable"
                            :items="questionables"
                            label="Questionable"
                            item-value="value"
                            :filter="filterQuestionables"
                            :error-messages="itemForm.errors.questionable"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            v-model="itemForm.vue_component"
                            rows="20"
                            no-resize
                            label="Vue Component (JSON)"
                            :error-messages="itemForm.errors.vue_component"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      :loading="itemForm.processing"
                      @click="save"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="deleteDialog" max-width="500px">
                <v-card>
                  <v-card-title class="headline">
                    Are you sure you want to delete this item?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="closeDelete">
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      :loading="itemForm.processing"
                      @click="deleteItemConfirm"
                    >
                      OK
                    </v-btn>
                    <v-spacer />
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template #[`item.questionable`]="{ item }">
            {{ questionableText(item) }}
          </template>
          <template #[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
          <template #no-data>
            Keine Fragen gefunden.
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Fragenübersicht',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      questions: {
         type: Array,
         required: true,
      },
      questionables: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         dialog: false,
         deleteDialog: false,
         headers: [
            { text: '#', value: 'id' },
            { text: 'Title', value: 'title' },
            { text: 'Artikel', value: 'questionable' },
            { text: 'Aktionen', value: 'actions', sortable: false },
         ],
         editedIndex: -1,
         itemForm: this.$inertia.form({
            title: null,
            vue_component: null,
            form_component: null,
            questionable: {},
         }),
      }
   },
   computed: {
      formTitle () {
         return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
   },

   watch: {
      dialog (val) {
         val || this.close()
      },
      deleteDialog (val) {
         val || this.closeDelete()
      },
      'itemForm.recentlySuccessful' (val) {
         if (val) {
            this.close()
            this.closeDelete()
            this.reset()
         }
      },
   },
   methods: {
      filterQuestionables (item, queryText, itemText) {
         return itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1
      },
      questionableText (item) {
         const questionable = this.questionables.find(function (element, index) {
            return (
               element.value.id === item.questionable_id &&
          element.value.type === item.questionable_type
            )
         })
         return questionable.text
      },
      editItem (item) {
         this.editedIndex = item.id

         this.itemForm.title = item.title
         this.itemForm.vue_component = item.vue_component
         this.itemForm.form_component = item.form_component
         const questionable = {
            id: item.questionable_id,
            type: item.questionable_type,
         }
         this.itemForm.questionable = questionable

         this.dialog = true
      },

      deleteItem (item) {
         this.editedIndex = item.id

         this.itemForm.title = item.title
         this.itemForm.vue_component = item.vue_component
         this.itemForm.form_component = item.form_component
         const questionable = {
            id: item.questionable_id,
            type: item.questionable_type,
         }
         this.itemForm.questionable = questionable

         this.deleteDialog = true
      },

      deleteItemConfirm () {
         this.$inertia.delete(this.route('question.destroy', this.editedIndex))
         this.closeDelete()
      },

      close () {
         this.dialog = false
         this.$nextTick(() => {
            this.reset()
            this.editedIndex = -1
         })
      },

      closeDelete () {
         this.deleteDialog = false
         this.$nextTick(() => {
            this.reset()
            this.editedIndex = -1
         })
      },

      reset () {
         this.itemForm.title = null
         this.itemForm.vue_component = null
         this.itemForm.form_component = null
         this.itemForm.questionable = {}
         this.itemForm.clearErrors()
      },

      save () {
         if (this.editedIndex > -1) {
            this.itemForm.put(this.route('question.update', this.editedIndex))
         } else {
            this.itemForm.post(this.route('question.store'))
         }
      },
   },
}
</script>

<style>
</style>
